module.exports = __webpack_public_path__ + "static/img/North_America_selected@2x.6783781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map/North_America_selected@2x.png
// module id = 579
// module chunks = 0